import React from "react";

const Banner = () => {
  return (
    <section className="banner-wrapper">
      <div className="banner-wrapper-background-img-container">
        <img className="banner-wrapper-background-img" src="/images/nokia-top-banner.png" alt="Banner background" />
      </div>
      <h1 className="banner-title">Get things done faster.</h1>
      
    </section>
  );
};

export default Banner;
